// Icon Pairs Data - 10 Zoho Workplace Apps with 2 icons each (20 icons total)
export const iconPairs = [
    {
        id: 0,
        productName: "ZOHO MAIL",
        icon1: "envelope",
        icon2: "computer",
        correctPair: ["envelope", "computer"],
        hint: "Where your work messages live. Combine how mail travels with where you type it.",
        features: {
            title1: "Slash Commands",
            description1: "Use slash commands in Mail Assistant to fetch and add data from other applications directly to your email composer.",
            title2: "Zia Writing Assistant",
            description2: "Check writing quality and readability, fix grammar, adjust tone, and refine for clarity in Mail."
        },
        unlockedIcon: "📧",
        productIcon: "mail"
    },
    {
        id: 1,
        productName: "ZOHO CALENDAR",
        icon1: "calendarPage",
        icon2: "clock",
        correctPair: ["calendarPage", "clock"],
        hint: "Never miss an event. Match the date keeper with the hour counter.",
        features: {
            title1: "Cliq Integration",
            description1: "Two-way sync lets you launch audio or video conferences and start group chats from events.",
            title2: "People Sync",
            description2: "View holidays, leave status, and org data from Zoho People inside Calendar."
        },
        unlockedIcon: "📅",
        productIcon: "calendar"
    },
    {
        id: 2,
        productName: "ZOHO CLIQ",
        icon1: "people",
        icon2: "phone",
        correctPair: ["people", "phone"],
        hint: "Stay in sync with your team. Connect your crew with the line that carries their voice.",
        features: {
            title1: "Auto Response On Mobile",
            description1: "Organize conversations by teams, projects, or topics in dedicated channels.",
            title2: "File Summaries",
            description2: "Summarize files shared in chat using the ChatGPT extension."
        },
        unlockedIcon: "💬",
        productIcon: "cliq"
    },
    {
        id: 3,
        productName: "ZOHO WORKDRIVE",
        icon1: "folder",
        icon2: "briefcase",
        correctPair: ["folder", "briefcase"],
        hint: "All of your files in one place. Match what holds them with what carries them.",
        features: {
            title1: "Zia In WorkDrive",
            description1: "Summarize files and translate comments with Zia, the built-in AI assistant.",
            title2: "AI Transcription (Beta)",
            description2: "Generate transcripts for audio and video files and jump to that part of the file by clicking timestamps."
        },
        unlockedIcon: "📁",
        productIcon: "workdrive"
    },
    {
        id: 4,
        productName: "ZOHO CONNECT",
        icon1: "building",
        icon2: "megaphone",
        correctPair: ["building", "megaphone"],
        hint: "Bring your organization together. Pair the office hub with what amplifies voices.",
        features: {
            title1: "Group Dashboard Insights",
            description1: "Manage member engagement, and track group events and announcements in a single view.",
            title2: "Smarter Search With NLP",
            description2: "Search the way you talk to find what you need. For example, 'tasks assigned to me last week.'"
        },
        unlockedIcon: "👥",
        productIcon: "connect"
    },
    {
        id: 5,
        productName: "ZOHO WRITER",
        icon1: "paper",
        icon2: "pencil",
        correctPair: ["paper", "pencil"],
        hint: "Every word starts somewhere. Pair the blank space with what writes on it.",
        features: {
            title1: "Interactive Document Generation",
            description1: "Create contracts, quotes, and orders that collaborators can directly fill and submit.",
            title2: "Enhanced Document Search",
            description2: "Search by meaning, not just keywords, to find similar phrases across documents."
        },
        unlockedIcon: "📝",
        productIcon: "writer"
    },
    {
        id: 6,
        productName: "ZOHO SHEET",
        icon1: "chart",
        icon2: "graph",
        correctPair: ["chart", "graph"],
        hint: "When data speaks. Combine two different visual ways of seeing numbers.",
        features: {
            title1: "Data Cleaning",
            description1: "Clean your data by filling missing values, removing duplicates, and fixing inconsistencies.",
            title2: "Ask Zia In Sheet",
            description2: "Ask Zia to create formulas, macros, tables, and get insights and answers with AI."
        },
        unlockedIcon: "📊",
        productIcon: "sheet"
    },
    {
        id: 7,
        productName: "ZOHO SHOW",
        icon1: "projector",
        icon2: "brush",
        correctPair: ["projector", "brush"],
        hint: "Present ideas beautifully. Link the stage for your slides with what adds expression.",
        features: {
            title1: "LiveCast",
            description1: "Stream presentations in real time and engage remote audiences directly from your deck.",
            title2: "Zia In Show",
            description2: "Create slide decks, generate visuals, and refine content using AI for impactful presentations."
        },
        unlockedIcon: "🎬",
        productIcon: "show"
    },
    {
        id: 8,
        productName: "ZOHO MEETING",
        icon1: "video",
        icon2: "globe",
        correctPair: ["video", "globe"],
        hint: "Meet anyone, anywhere. Pair what captures you with what spans the world.",
        features: {
            title1: "Live Stream Webinars",
            description1: "Broadcast webinars to major social platforms to engage audiences in real time.",
            title2: "Zapier Integration",
            description2: "Connect Meeting with thousands of apps to automate workflows without coding."
        },
        unlockedIcon: "🎥",
        productIcon: "meeting"
    },
    {
        id: 9,
        productName: "ZOHO VAULT",
        icon1: "lock",
        icon2: "key",
        correctPair: ["lock", "key"],
        hint: "Passwords stay protected. Pair what guards with what grants entry.",
        features: {
            title1: "Passkey Management",
            description1: "Manage passwords and passkeys together across web, extensions, and mobile for easier secure logins.",
            title2: "Vault Desktop App",
            description2: "Use a native Windows application for faster, seamless password and data management."
        },
        unlockedIcon: "🔐",
        productIcon: "vault"
    }
];

// Create flat array of all 20 icons
export const allIcons = iconPairs.flatMap(pair => [
    { id: `${pair.id}-1`, productId: pair.id, iconName: pair.icon1, productName: pair.productName },
    { id: `${pair.id}-2`, productId: pair.id, iconName: pair.icon2, productName: pair.productName }
]);

// Shuffle function to randomize icons
export function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

// Get initial 10 random icons from the pool
export function getInitialIcons() {
    return shuffleArray(allIcons).slice(0, 10);
}

// Keep old products data for backward compatibility during migration
export const products = [
    {
        id: 0,
        name: "ZOHO MAIL",
        icon: "mail",
        correctCategory: "laptop",
        iconSet: 'set1',
        features: {
            title1: "Slash commands",
            description1: "Create and use slash commands to invoke any application from the Mail Assistant.",
            title2: "Settings customisation",
            description2: "Gives admins more control over what features your users can access or modify, based on their roles."
        },
        nextHint: "Try combining Calendar page icon with the icon that shows Time.",
        unlockedIcon: "📧"
    },
    {
        id: 1,
        name: "ZOHO CALENDAR",
        icon: "calendar",
        correctCategory: "clock",
        iconSet: 'set2',
        features: {
            title1: "Smart scheduling",
            description1: "AI-powered meeting scheduler that finds the best time for all participants automatically.",
            title2: "Event templates",
            description2: "Create reusable templates for recurring meetings and events to save time."
        },
        nextHint: "Match the Business icon with Documents to discover project management.",
        unlockedIcon: "📅"
    },
    {
        id: 2,
        name: "ZOHO PROJECTS",
        icon: "projects",
        correctCategory: "briefcase",
        iconSet: 'set3',
        features: {
            title1: "Task automation",
            description1: "Automate repetitive tasks and workflows to keep your projects moving efficiently.",
            title2: "Gantt charts",
            description2: "Visualize project timelines and dependencies with interactive Gantt charts."
        },
        nextHint: "Combine Phone icon with Briefcase for customer relationship tools.",
        unlockedIcon: "📊"
    },
    {
        id: 3,
        name: "ZOHO CRM",
        icon: "crm",
        correctCategory: "phone",
        iconSet: 'set4',
        features: {
            title1: "AI Sales Assistant",
            description1: "Zia, your AI assistant, helps predict deals, detect anomalies, and automate tasks.",
            title2: "Omnichannel communication",
            description2: "Connect with customers via email, phone, live chat, and social media from one place."
        },
        nextHint: "Match Documents with Folder to unlock document management.",
        unlockedIcon: "📞"
    },
    {
        id: 4,
        name: "ZOHO DOCS",
        icon: "docs",
        correctCategory: "document",
        iconSet: 'set5',
        features: {
            title1: "Real-time collaboration",
            description1: "Work together on documents, spreadsheets, and presentations in real-time.",
            title2: "Version control",
            description2: "Automatic versioning ensures you never lose important changes to your documents."
        },
        nextHint: "The Folder icon reveals cloud storage solutions.",
        unlockedIcon: "📝"
    },
    {
        id: 5,
        name: "ZOHO WORKDRIVE",
        icon: "workdrive",
        correctCategory: "folder",
        iconSet: 'set6',
        features: {
            title1: "Team folders",
            description1: "Organize files into team folders with customizable access permissions.",
            title2: "Advanced search",
            description2: "Find any file instantly with powerful search across content, comments, and metadata."
        },
        nextHint: "Try the Laptop icon to discover the presentation tool.",
        unlockedIcon: "📁"
    },
    {
        id: 6,
        name: "ZOHO SHOW",
        icon: "show",
        correctCategory: "laptop",
        iconSet: 'set7',
        features: {
            title1: "Remote presenting",
            description1: "Present to remote audiences with built-in broadcasting and recording features.",
            title2: "Smart templates",
            description2: "Choose from professionally designed templates that adapt to your content."
        },
        nextHint: "Match Clock with Document for time tracking software.",
        unlockedIcon: "🎬"
    },
    {
        id: 7,
        name: "ZOHO TIMESHEET",
        icon: "timesheet",
        correctCategory: "clock",
        iconSet: 'set8',
        features: {
            title1: "Automated tracking",
            description1: "Automatically track time spent on tasks and projects with minimal effort.",
            title2: "Billing integration",
            description2: "Convert tracked hours into invoices seamlessly with billing integration."
        },
        nextHint: "Combine Briefcase with Laptop for analytics platform.",
        unlockedIcon: "⏱️"
    },
    {
        id: 8,
        name: "ZOHO ANALYTICS",
        icon: "analytics",
        correctCategory: "briefcase",
        iconSet: 'set9',
        features: {
            title1: "AI-powered insights",
            description1: "Get intelligent insights and predictions powered by Zia, our AI assistant.",
            title2: "Custom dashboards",
            description2: "Create beautiful, interactive dashboards that update in real-time."
        },
        nextHint: "Use the Phone icon to unlock the final communication tool.",
        unlockedIcon: "📈"
    },
    {
        id: 9,
        name: "ZOHO MEETING",
        icon: "meeting",
        correctCategory: "phone",
        iconSet: 'set10',
        features: {
            title1: "HD video conferencing",
            description1: "Host secure video meetings with up to 250 participants in crystal-clear quality.",
            title2: "Screen sharing",
            description2: "Share your screen, whiteboard, and collaborate with powerful annotation tools."
        },
        nextHint: "Congratulations! You've discovered all 10 Zoho products!",
        unlockedIcon: "🎥"
    }
];
